/**
 * @generated SignedSource<<96f2e1163ac71e37c82a8468a181e59b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type failedBuild_periscope_FailedBuildTask$data = {
  readonly __typename: "WorkSuggestionsBuildTask";
  readonly id: string;
  readonly issueKey: string;
  readonly lastUpdated: string;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "failedBuild_periscope_FailedBuildTask";
};
export type failedBuild_periscope_FailedBuildTask$key = {
  readonly " $data"?: failedBuild_periscope_FailedBuildTask$data;
  readonly " $fragmentSpreads": FragmentRefs<"failedBuild_periscope_FailedBuildTask">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "failedBuild_periscope_FailedBuildTask",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "issueKey"
    },
    {
      "kind": "ScalarField",
      "name": "lastUpdated"
    }
  ],
  "type": "WorkSuggestionsBuildTask"
};

(node as any).hash = "789f373f3c12f46c5ec6c615427ac5cd";

export default node;
